import styled from "styled-components/native";
import { spacing_s } from "../../StyleHelpers";

export const StyledWrapper = styled.View`
	z-index: -1;
	top: 15vh;
	overflow: hidden;
	margin: 0 14.1% 70px 14.1%;
`;

export const StyledButtonContainer = styled.View`
	flex-direction: column;
	width: 71.8%;
	position: absolute;
	bottom: 10%;
	margin: 0 14.1% 0 14.1%;
	gap: 1.5rem;
`;

export const StyledFormContainer = styled.View`
	margin-top: 82px;
	flex-direction: column;
	width: 100%;
`;

export const StyledButtonMainContainer = styled.View`
	display: flex;
	flex-direction: row;
	gap: ${spacing_s};
`;

/*Narrow*/
export const StyledNarrowButtonsContainer = styled.View`
	display: flex;
	width: 31.25rem;
	flex-direction: column;
	align-items: flex-start;
	gap: ${spacing_s};
	align-self: stretch;
`;

export const StyledNarrowButtonsWrapper = styled.View`
	display: flex;
	flex-direction: column;
	// align-items: flex-start;
	gap: ${spacing_s};
	align-self: stretch;
`;

export const StyledNarrowTextInput = styled.View`
	display: flex;
	flex-direction: column;
	gap: ${spacing_s};
	flex: 1 0 0;
`;

export const StyledNarrowTextContainer = styled.View<any>`
	margin-top: -6px;
	gap: ${(props) => (props.isGap ? "0.5rem" : 0)};
`;
